import { NgForOf, NgIf, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';

import { OverlayModule } from '@recruitee/cdk/overlay';
import { TranslatePipe } from '@recruitee/i18n';
import {
  ButtonComponent,
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownHeaderComponent,
  DropdownItemComponent,
  HeadingComponent,
  IconButtonComponent,
  IconComponent,
  IconHelpWithDropdownComponent,
  OverlayOriginDirective,
  RtTooltip,
} from '@recruitee/user-interface';

import { WysiwygInlineButtonModule } from '../../wysiwyg-inline-button/wysiwyg-inline-button.module';
import { InsertPlaceholderInputDirective } from './insert-placeholder-input.directive';
import { InsertPlaceholderDirective } from './insert-placeholder.directive';
import { PlaceholderButtonComponent } from './placeholder-button/placeholder-button.component';
import { PlaceholderCategoryButtonComponent } from './placeholder-category-button/placeholder-category-button.component';
import { PlaceholderCategorySelectDropdownComponent } from './placeholder-category-select-dropdown/placeholder-category-select-dropdown.component';
import { PlaceholderSelectDropdownComponent } from './placeholder-select-dropdown/placeholder-select-dropdown.component';
import { PlaceholderService } from './placeholder.service';
import { PlaceholdersListComponent } from './placeholders-list/placeholders-list.component';
import { WysiwygPlaceholderDropdownComponent } from './wysiwyg-placeholder/wysiwyg-placeholder-dropdown/wysiwyg-placeholder-dropdown.component';
import { WysiwygPlaceholderTypeaheadComponent } from './wysiwyg-placeholder/wysiwyg-placeholder-typeahead/wysiwyg-placeholder-typeahead.component';
import { WysiwygPlaceholderComponent } from './wysiwyg-placeholder/wysiwyg-placeholder.component';

@NgModule({
  imports: [
    ButtonComponent,
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownHeaderComponent,
    DropdownItemComponent,
    HeadingComponent,
    IconButtonComponent,
    IconComponent,
    IconHelpWithDropdownComponent,
    InsertPlaceholderDirective,
    OverlayModule,
    OverlayOriginDirective,
    RtTooltip,
    WysiwygInlineButtonModule,
    TranslatePipe,
    NgForOf,
    NgTemplateOutlet,
    NgIf,
  ],
  providers: [PlaceholderService],
  declarations: [
    InsertPlaceholderInputDirective,
    PlaceholdersListComponent,
    WysiwygPlaceholderComponent,
    WysiwygPlaceholderDropdownComponent,
    PlaceholderButtonComponent,
    PlaceholderCategoryButtonComponent,
    PlaceholderSelectDropdownComponent,
    PlaceholderCategorySelectDropdownComponent,
    WysiwygPlaceholderTypeaheadComponent,
  ],
  exports: [
    InsertPlaceholderDirective,
    InsertPlaceholderInputDirective,
    PlaceholdersListComponent,
    WysiwygPlaceholderComponent,
    PlaceholderCategorySelectDropdownComponent,
  ],
})
export class WysiwygPlaceholderModule {}

export * from './insert-placeholder.directive';
export * from './insert-placeholder-input.directive';
export * from './placeholders-list/placeholders-list.component';
export * from './placeholder.service';
export * from './placeholder';
export * from './wysiwyg-placeholder/wysiwyg-placeholder.component';
export * from './placeholder-category-select-dropdown/placeholder-category-select-dropdown.component';
